import { isPrimaryOrSecondaryColor } from '../../utils';
import { menuAnatomy as parts } from '@chakra-ui/anatomy';
import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools';
import type { PartsStyleFunction } from '@chakra-ui/theme-tools';

const baseStyle: PartsStyleFunction<typeof parts> = (
  props: StyleFunctionProps,
) => {
  const color = props.colorScheme;
  return {
    groupTitle: {
      color: isPrimaryOrSecondaryColor(color)
        ? color
        : mode(`${color}.600`, `${color}.300`),
      fontWeight: 'normal',
      my: 1,
      textAlign: 'left',
    },
    button: {
      minH: 8,
      bg: isPrimaryOrSecondaryColor(color)
        ? color
        : mode(`${color}.700`, `${color}.500`),
    },

    list: {
      minW: 36,
      border: 0,
      boxShadow:
        '0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px rgb(0 0 0 / 8%), 0 9px 28px 8px rgb(0 0 0 / 5%)',
    },
    item: { h: 8 },
  };
};

export default {
  parts: parts.keys,
  baseStyle,
};
